import Vue from 'vue'

// Lib imports
import Axios from 'axios'

Vue.prototype.$http = Axios


const TOKEN="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2V4dGVybmFsX2lkIjoidXNlcjAwMDEiLCJzY29wZSI6InVzZXIwMDAxIiwiaWF0IjoxNTU0MDk3NzU0fQ.yOQEWHOuznaHL20bd-TAGZ44rqEvO7h45AbuXNNLWRM"
const API_URL=process.env.VUE_APP_API_ENDPOINT


Axios.defaults.baseURL=API_URL
Axios.defaults.headers.common = {'Authorization': `Bearer ${TOKEN}`}

Axios.interceptors.request.use(request => {
  console.log('Starting Request', request)
  return request
})

Axios.interceptors.response.use(response => {
  console.log('Response:', response)
  return response
})